export default __webpack_public_path__ + "apple-logo.png";